module.exports = __webpack_public_path__ + "static/media/tab-wavy-crunchy.92f10535.png";